import React, { PropsWithChildren } from "react";
//#region types
import { ViewPanelOuterProps } from "models/propTypes/panelsPropsTypes";
//#endregion
//#region components
import { Fade, Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const ViewPanelOuter: React.FC<PropsWithChildren<ViewPanelOuterProps>> = (props) => {
  return (
    <Fade in timeout={600}>
      <Grid
        item
        container
        md={
          props.gridSize
            ? props.gridSize === "xs"
              ? 4
              : props.gridSize === "sm"
              ? 6
              : props.gridSize === "md"
              ? 6
              : 12
            : 12
        }
        lg={
          props.gridSize
            ? props.gridSize === "xs"
              ? 3
              : props.gridSize === "sm"
              ? 4
              : props.gridSize === "md"
              ? 6
              : 12
            : 12
        }
      >
        <Grid
          item
          container
          direction="column"
          className={clsx(
            cssExports.viewPanelOuter,
            props.appearance === "md"
              ? cssExports.viewPanelMd
              : props.appearance === "sm"
              ? cssExports.viewPanelSm
              : "",
            props.fitContent ? cssExports.fitContent : "",
            props.className
          )}
        >
          {props.children}
        </Grid>
      </Grid>
    </Fade>
  );
};

export default ViewPanelOuter;
